import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const LoginService = {
  login(obj) {
    return httpClient.post(endPoints.loginCompCode, obj);
  },
  forgotpassword(obj) {
    return httpClient.post(endPoints.forgotpassword, obj);
  },
  resetPassword(obj) {
    return httpClient.post(endPoints.resetPassword, obj);
  },
  changeLang(obj) {
    return httpClient.post(endPoints.changeLang, obj);
  }
};

export default LoginService;



// WEBPACK FOOTER //
// ./src/service/LoginService.js